export const REPORT_PAGE_SIZE = 100;

export const buildReportParams = (filters) => {
  const params = {};
  Object.entries(filters).forEach(([key, value]) => {
    if (!['start_date', 'end_date', 'start_time', 'end_time'].includes(key) && value && value !== '_all_') {
      params[key] = value;
    }
  });
  if ((filters.start_time && !filters.start_date) || (filters.end_time && !filters.end_date)) {
    throw new Error('Informe a data correspondente ao horário escolhido.');
  }
  if (filters.start_date) {
    const start = new Date(`${filters.start_date}T${filters.start_time || '00:00'}:00`);
    params.start_at = start.toISOString();
  }
  if (filters.end_date) {
    const end = new Date(`${filters.end_date}T${filters.end_time || '00:00'}:00`);
    // Include the entire final minute, or the entire final day when no time is set.
    if (filters.end_time) end.setMinutes(end.getMinutes() + 1);
    else end.setDate(end.getDate() + 1);
    params.end_before = end.toISOString();
  }
  if (params.start_at && params.end_before && params.start_at >= params.end_before) {
    throw new Error('O início do período deve ser anterior ao fim.');
  }
  return params;
};

export const getReportPages = (currentPage, totalPages) => {
  const pages = new Set([1, totalPages]);
  const start = Math.max(1, Math.min(currentPage - 1, totalPages - 2));
  for (let page = start; page <= Math.min(totalPages, start + 2); page += 1) pages.add(page);
  const result = [];
  [...pages].sort((a, b) => a - b).forEach((page) => {
    const previous = result[result.length - 1];
    if (typeof previous === 'number' && page > previous + 1) result.push(`gap-${page}`);
    result.push(page);
  });
  return result;
};
